import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Expand } from '../Expand';
import './ReadMoreButton.scss';
import { Paragraph } from '../Typography/Typography';

export const ReadMoreButton = ({ children }) => {
	const [expanded, setExpanded] = useState(false);

	const handleToggle = () => {
		setExpanded((prev) => !prev);
	};

	return (
		<div className="read-more">
			<Expand
				showing={expanded}
				showTeaser={true}
			>
				<div className="read-more-content">{children}</div>
			</Expand>
			<button
				onClick={() => {
					handleToggle();
				}}
				className="read-more-toggle"
			>
				<Paragraph
					size="tall"
					color="gray"
				>
					{expanded ? ' - Read Less' : ' + Read More'}
				</Paragraph>
			</button>
		</div>
	);
};

ReadMoreButton.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ReadMoreButton;
